export enum TitleFunctionType {
	Download = 0,
	ConsultRecord = 1,
	ViewOnline = 2
}